import {
	reactive,
	computed,
	toRefs,
	watch,
} from '@vue/composition-api';

const allocateChannel = (props, context, options = {}) => {
	const { defaultState = {} } = options;
	const event = reactive({
		channels: defaultState.channels || [],
		total: defaultState.total || 0,
		transformChannels: computed(() => {
			return event.channels.map((channel) => {
				return {
					...channel,
					qty: (event.total * channel.percentage) / 100,
				};
			});
		}),
	});

	const watchPropValue = (newValue) => {
		event.channels = newValue;
	};

	const watchPropTotal = (newTotal) => {
		event.total = newTotal;
	};

	watch(() => props.value, watchPropValue);

	watch(() => props.total, watchPropTotal);

	return {
		...toRefs(event),
	};
};

export default allocateChannel;